import Vue from 'vue'
import { ButtonGroup, Button, Drawer, Image, Dialog, Row, Col, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'

Vue.use(ButtonGroup)
Vue.use(Button)
Vue.use(Drawer)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(Col)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
